import { render, staticRenderFns } from "./AppVariable.vue?vue&type=template&id=ee56ab98&"
import script from "./AppVariable.vue?vue&type=script&lang=js&"
export * from "./AppVariable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports